// registers dependencies in injector
import '@/register-dependencies';

import { startup } from '@/startup/index';

// eslint-disable-next-line
__webpack_public_path__ = window.store.scriptsPath;

startup();
